import { render } from "./Portfolios.vue?vue&type=template&id=245a41df&scoped=true"
import script from "./Portfolios.vue?vue&type=script&lang=js"
export * from "./Portfolios.vue?vue&type=script&lang=js"

import "./Portfolios.vue?vue&type=style&index=0&id=245a41df&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245a41df"]])

export default __exports__